"use client";
import React, { useEffect, useState } from "react";
import Image from "next/image";
import {
  Grid,
  Stack,
  Typography,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import { IMAGES, WEB_COLORS, CurrencyConverter } from "@/lib/constants";
import { useTranslations } from "next-intl";
import { Check } from "@mui/icons-material";
import { DividerComponent } from "@/components";
import { usePathname } from "next/navigation";
import CreditScoreLeftCard from "@/screens/credit-score/credit-score-login/LoginLeft";

const PARTNER_CONFIG = [
  {
    key: "buddyloan",
    image: IMAGES.buddyLoan,
    imageStyle: { cursor: "pointer", marginLeft: -16 },
    dividerSx: {
      height: { xs: "2em", sm: "4em" },
      mr: 2,
      borderColor: "#fff",
    },
  },
  {
    key: "creditmantri",
    image: IMAGES.creditMantri,
    imageStyle: { cursor: "pointer", marginLeft: -16 },
    dividerSx: {
      height: { xs: "2em", sm: "4em" },
      borderColor: "#fff",
    },
  },
  {
    key: "bharatpe",
    image: IMAGES.bharatPe,
    imageStyle: { cursor: "pointer" },
    dividerSx: {
      height: { xs: "2em", sm: "4em" },
      borderColor: "#fff",
    },
  },
  {
    key: "switchmyloan",
    image: IMAGES.switchMyLoan,
    imageStyle: { cursor: "pointer" },
    dividerSx: {
      height: { xs: "2em", sm: "4em" },
      borderColor: "#fff",
    },
  },
  {
    key: "cpadvisor",
    image: IMAGES.cpAdvisor,
    imageStyle: { cursor: "pointer" },
    dividerSx: {
      height: { xs: "2em", sm: "4em" },
      borderColor: "#fff",
    },
  },
  {
    key: "pw",
    image: IMAGES.pwLogo,
    imageStyle: { cursor: "pointer" },
    dividerSx: {
      height: { xs: "2em", sm: "4em" },
      borderColor: "#fff",
    },
  },
];

const LeftCard = ({ utmCampaign, product }) => {
  const t = useTranslations("Login");
  const theme = useTheme();
  const isBelowMd = useMediaQuery(theme.breakpoints.down("sm"));
  const path = usePathname();
  const normalizedCampaign = utmCampaign?.toLowerCase() || "";
  const activePartner = PARTNER_CONFIG.find(({ key }) =>
    normalizedCampaign.includes(key),
  );
  return (
    <Stack
      height={"100%"}
      p={{ xs: 3, sm: 6 }}
      gap={1}
      justifyContent={"flex-start"}
    >
      <Stack direction={"row"} alignItems={"center"} width={"100%"} gap={2}>
        <Image
          onClick={() => (window.location.href = "https://www.herofincorp.com")}
          src={IMAGES.instantpersonalloanlogo}
          height={80}
          width={132}
          alt="Banner"
          priority={false}
          style={{ cursor: "pointer", marginLeft: -16 }}
        />
        {activePartner && (
          <>
            <DividerComponent
              orientation="vertical"
              variant="middle"
              sx={activePartner.dividerSx}
            />
            <Image
              onClick={() =>
                (window.location.href = "https://www.herofincorp.com")
              }
              src={activePartner.image}
              height={80}
              width={150}
              alt="Banner"
              priority={false}
              style={activePartner.imageStyle}
            />
          </>
        )}
      </Stack>
      {product === "credit-score" && <CreditScoreLeftCard />}

      {product !== "credit-score" && (
        <Stack>
          <Stack spacing={2}>
            <Stack>
              <Typography
                variant="h4"
                fontWeight={"bold"}
                color={"#FFFFFF"}
                fontSize={{ md: 32, xs: 28 }}
              >
                {t("welcome")}
              </Typography>

              <Typography
                variant="h6"
                align="left"
                fontSize={{ xs: 16, sm: 20 }}
                color={"#FFFFFF"}
              >
                {path.includes("consumer")
                  ? "Big dreams, small EMI's- Instant loans upto "
                  : path.includes("medical")
                    ? "Urgent medical care, backed by instant funds upto "
                    : "Quick, easy loans up to "}
                <Typography
                  variant="subtitle"
                  align="center"
                  color={"#00F200"}
                  fontSize={{ xs: 16, sm: 24 }}
                >
                  {CurrencyConverter(700000)}
                </Typography>
              </Typography>
            </Stack>
            <Stack gap={{ xs: 0, sm: 0.5 }}>
              <Stack direction={"row"} alignItems={"center"} spacing={1}>
                <Check
                  fontSize={`${isBelowMd ? 16 : 20}`}
                  sx={{ color: "#fff" }}
                />
                <Typography
                  color={"#fff"}
                  fontSize={{ xs: 12, sm: 12, md: 16 }}
                >
                  Easy Personal loan for all purposes
                </Typography>
              </Stack>
              <Stack direction={"row"} alignItems={"center"} spacing={1}>
                <Check
                  fontSize={`${isBelowMd ? 16 : 20}`}
                  sx={{ color: "#fff" }}
                />
                <Typography
                  color={"#fff"}
                  fontSize={{ xs: 12, sm: 12, md: 16 }}
                >
                  Avail collateral-free loans
                </Typography>
              </Stack>
              <Stack direction={"row"} alignItems={"center"} spacing={1}>
                <Check
                  fontSize={`${isBelowMd ? 16 : 20}`}
                  sx={{ color: "#fff" }}
                />
                <Typography
                  color={"#fff"}
                  fontSize={{ xs: 12, sm: 12, md: 16 }}
                >
                  Seamless login process
                </Typography>
              </Stack>
              <Stack direction={"row"} alignItems={"center"} spacing={1}>
                <Check
                  fontSize={`${isBelowMd ? 16 : 20}`}
                  sx={{ color: "#fff" }}
                />
                <Typography
                  color={"#fff"}
                  fontSize={{ xs: 12, sm: 12, md: 16 }}
                >
                  Simple repayment
                </Typography>
              </Stack>
            </Stack>
          </Stack>
          <Stack gap={{ xs: 0.5 }}>
            <Grid container>
              <Grid item xs={12} sm={8} md={8}>
                <Stack gap={{ xs: 0.5, sm: 2 }}>
                  <Stack
                    direction={"row"}
                    spacing={1}
                    p={1}
                    sx={{ border: `1px solid ${WEB_COLORS.secondary}` }}
                    borderRadius={2}
                    alignItems={"center"}
                  >
                    <Image
                      src={IMAGES.quicktime}
                      alt="Banner"
                      height={isBelowMd ? 20 : 32}
                      width={isBelowMd ? 20 : 32}
                    />
                    <Typography fontSize={{ xs: 10, sm: 14 }} color={"#fff"}>
                      Calculate your EMI within minutes
                    </Typography>
                  </Stack>
                  <Stack
                    direction={"row"}
                    spacing={1}
                    p={1}
                    sx={{ border: `1px solid ${WEB_COLORS.secondary}` }}
                    borderRadius={2}
                    alignItems={"center"}
                  >
                    <Image
                      src={IMAGES.percentage}
                      alt="Banner"
                      height={isBelowMd ? 20 : 32}
                      width={isBelowMd ? 20 : 32}
                    />
                    <Typography fontSize={{ xs: 10, sm: 14 }} color={"#fff"}>
                      Low interest rates & minimal processing fees
                    </Typography>
                  </Stack>
                  <Stack
                    direction={"row"}
                    spacing={1}
                    p={1}
                    sx={{ border: `1px solid ${WEB_COLORS.secondary}` }}
                    borderRadius={2}
                    alignItems={"center"}
                  >
                    <Image
                      src={IMAGES.applogo}
                      alt="Banner"
                      height={isBelowMd ? 20 : 32}
                      width={isBelowMd ? 20 : 32}
                    />
                    <Typography fontSize={{ xs: 10, sm: 14 }} color={"#fff"}>
                      24x7 access to personal loan app
                    </Typography>
                  </Stack>
                </Stack>
              </Grid>
            </Grid>
            {path?.includes("personal") && (
              <Grid container>
                <Grid
                  item
                  xs={12}
                  sm={12}
                  md={12}
                  sx={{
                    position: "relative",
                    height: "fit-content",
                    height: isBelowMd ? 111 : 200,
                  }}
                >
                  <Stack
                    direction={"row"}
                    alignItems={"center"}
                    justifyContent={"flex-end"}
                    position={"absolute"}
                    right={isBelowMd ? -50 : -74}
                  >
                    <Image
                      src={IMAGES.loanhand}
                      alt="Banner"
                      height={isBelowMd ? 111 : 200}
                      width={isBelowMd ? 150 : 320}
                    />
                  </Stack>
                </Grid>
              </Grid>
            )}
          </Stack>
        </Stack>
      )}
    </Stack>
  );
};

export default LeftCard;
